import { Directive, Input } from "@angular/core";
import { NG_VALIDATORS, Validator, AbstractControl } from "@angular/forms";
import { pixelTagValidator } from "../utils/commonUtils";

@Directive({
  selector: "[pixelTagValidator]",
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: PixelTagValidatorDirective,
      multi: true,
    },
  ],
})

export class PixelTagValidatorDirective implements Validator {
  @Input("pixelTagValidator") pixelType: "js" | "image" = "js";

  validate(control: AbstractControl) {
    return pixelTagValidator(this.pixelType)(control);
  }
}
